/* eslint-disable */
import { Reducer } from 'redux'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { API } from 'src/services/config'

interface IBloodGradeState {
  idGrau: string
  descricao: string
}

export interface BloodGradeState {
  loading: boolean
  list: Array<IBloodGradeState>
}

const customModule = '@BLOOD_GRAU'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
  FAILED: `${customModule}/GET_FAILED`
}

const initialState: BloodGradeState = {
  loading: false,
  list: []
}

export const bloodGradeReducer: Reducer<BloodGradeState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, isLoading: true }
    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }
    case GET.FAILED:
      return { ...state, isLoading: false }
    default:
      return state
  }
}

export const getBloodGradeList = () => ({ type: GET.REQUEST })

const ROUTE = '/entity/Sangue'

function* get({ payload }: SagaAction<string>) {
  try {
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}`)
    const dataOrdered = data.sort((a: any, b: any) => a.descricao.localeCompare(b.descricao))
    yield put({ type: GET.SUCCESS, payload: dataOrdered })
  } catch (error: any) {
    yield put({ type: GET.FAILED })
    throw new Error(error?.response?.data || 'Erro ao buscar lista de sangue.')
  }
}

export const bloodGradeSaga = all([takeLatest(GET.REQUEST, get)])
